import { render, staticRenderFns } from "./GestionUsuarios.vue?vue&type=template&id=4ddd7254&"
import script from "./GestionUsuarios.vue?vue&type=script&lang=js&"
export * from "./GestionUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports